import * as React from "react";
import { cn } from "@/lib/utils";

export interface NeonCardProps extends React.HTMLAttributes<HTMLDivElement> {
  hover?: boolean;
}

export const NeonCard = React.forwardRef<HTMLDivElement, NeonCardProps>(
  ({ className, hover = true, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "relative rounded-xl bg-dark-card border border-lime/10 text-white shadow-card transition-transform duration-300 ease-cinematic",
          hover && "hover:-translate-y-1 hover:shadow-neon-glow hover:border-lime/40",
          className
        )}
        {...props}
      />
    );
  }
);

NeonCard.displayName = "NeonCard";

export const NeonCardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-8", className)} {...props} />
));

NeonCardContent.displayName = "NeonCardContent";

export default NeonCard;


